<template>
  <div class="tfm_job_board">
    <div class="generic-filter row m-0 align-items-center justify-content-between">
      <!-- this is generic filter -->
       <div class="col-12 col-md-6 flex-grow-1 flex-basis-100 flex-md-basis-auto mb-2 mb-md-0">
        <SearchBar
          :value="searchTerm"
          :searchCallback="searchCallback"
        />
      </div>
      <!-- <button class="border-0">
      <span class="icon-menu-three-dots"></span>
      </button>-->
      <div class="col-12 col-md-6 d-flex flex-wrap gap-2 justify-content-end w-100 w-md-auto">
        <div class="m-1" v-if="getUserId && !hideFavoriteBtn">
          <CDropdown color="primary" :toggler-text="favouriteTemplate.name">
            <div class="mr-2 ml-2 filter-search" v-if="favouriteFilters.length">
              <CInput
                placeholder="Search"
                name="bookmark-search"
                v-model="searchFilterName"
              >
                <template #prepend-content>
                  <CIcon name="cil-magnifying-glass" />
                </template>
              </CInput>
            </div>
            <div class="filter-list">
              <CDropdownItem
                v-for="(favouriteFilter, fIndex) in favouriteFilterList(
                  searchFilterName
                )"
                :key="fIndex"
                v-c-tooltip="{
                  content: favouriteFilter.filter_name_date,
                }"
              >
                <a
                  href="javascript:"
                  @click="navigateToBookMarkedUrl(favouriteFilter.url)"
                >
                  <label class="px-1 pt-2 mb-0 primary text-truncate">
                    {{ favouriteFilter.filter_name_date }}
                  </label>
                </a>
                <button
                  class="border-0 btn-primary"
                  v-if="!favouriteFilter.isDefault"
                  @click="editBookmark(favouriteFilter)"
                >
                  <i class="fas fa-pencil-alt" aria-hidden="true"></i>
                </button>
                <button
                  class="border-0 btn-primary ml-1"
                  v-if="!favouriteFilter.isDefault"
                  @click="deleteBookmark(favouriteFilter)"
                >
                  <i class="fas fa-trash-alt" aria-hidden="true"></i>
                </button>
              </CDropdownItem>
              <div
                v-if="!favouriteFilterList.length && searchFilterName"
                class="mr-3 ml-3 text-center"
              >
                <h5>No Bookmark Match</h5>
              </div>
              <CDropdownDivider
                v-if="favouriteFilterList.length"
              ></CDropdownDivider>
            </div>
            <CDropdownItem>
              <CButton
                class="btn btn-primary w-100"
                @click="addBookmarkModal()"
                size="sm"
                >Add {{ favouriteTemplate.content }}</CButton
              >
            </CDropdownItem>
          </CDropdown>
        </div>
        <div class="m-1" v-if="isShowGroup">
          <CDropdown color="primary" class="d-flex" toggler-text="Groups">
            <div class="filter-list">
              <CDropdownItem
                v-for="(group, fIndex) in getJobGroups"
                :key="fIndex"
              >
                <a href="javascript:" @click="navigateToGroupUrl(group)">
                  <label class="px-1 pt-2 mb-0 primary text-truncate">
                    {{ group.group_name }}
                  </label>
                </a>
                <button class="border-0 btn-primary" @click="editJobGroup(group)">
                  <i class="fas fa-pencil-alt" aria-hidden="true"></i>
                </button>
                <button
                  class="border-0 btn-primary ml-1"
                  @click="removeJobGroup(group)"
                >
                  <i class="fas fa-trash-alt" aria-hidden="true"></i>
                </button>
              </CDropdownItem>
              <div class="mr-3 ml-3 text-center"></div>
              <CDropdownDivider></CDropdownDivider>
            </div>
            <CDropdownItem>
              <CButton
                class="btn btn-primary w-100"
                @click="addJobGroup"
                size="sm"
                >Add Job Group</CButton
              >
            </CDropdownItem>
          </CDropdown>
        </div>
        <div class="m-1" v-if="$route.path.includes('/candidate-list')">
          <CButton
            title="Table View"
            class="d-flex"
            key="primary"
            color="primary"
            @click="showTableView()"
            :disabled="isFetchingFilter"
          >
            <span>View&nbsp;</span>
            <i class="fa-solid fa-table"></i>
          </CButton>
        </div>
        
        <div class="m-1" v-if="isCandidateRoute">
          <CampaignBookmark />
        </div>
        <div class="m-1">
          <CButton
            class="d-flex"
            key="primary"
            color="primary"
            @click="toggleSideBar"
            :disabled="isFetchingFilter"
          >
            Filter
            <CIcon name="cil-filter" size="sm" />
          </CButton>
          <!-- <div
              style="cursor:pointer;display: -webkit-inline-box"
              class="m-0 p-0"
              @click="toggleSideBar"
            >
              <p class="d-inline mb-0 ml-4">Filter</p>
              <button :disabled="isFetchingFilter" class="border-0">
                <i class="fa fa-filter" aria-hidden="true"></i>
              </button>
          </div>-->
        </div>
        <div class="m-1" v-if="$route.path.includes('/candidate-list/short_registration') || 
              $route.path.includes('/candidate-list/super_customer/short_registration')">
          <CButton
            title="Download Candidate List"
            class="d-flex"
            key="primary"
            color="primary"
            @click="downloadShortRegCandidates()"
            :disabled="isFetchingFilter"
          >
            <i class="fa-solid fa-download"></i>
          </CButton>
        </div>
        <div class="m-1" v-if="backURL">
          <CButton key="back" color="primary" :to="backURL">Back</CButton>
        </div>
        <div class="m-1" v-if="fullBackURL">
          <CButton key="back" color="primary" :href="fullBackURL">Back</CButton>
        </div>
      </div>
      <sidebar :show="sideBarShow" :toggleSideBar="toggleSideBar">
        <template #header>
          <div class="d-flex justify-content-between align-items-center">
            <div class="d-flex align-items-center">
              <button
                :disabled="isFetchingFilter"
                @click="toggleSideBar"
                class="btn btn-primary ml-1 mr-2"
              >
                <i class="fa fa-arrow-right" aria-hidden="true"></i>
              </button>
              <h5 class="m-0">Selected Filters</h5>
            </div>
            <span
              v-if="selectedFilterLength"
              @click="clearAllFilters"
              style="cursor: pointer"
              class="pr-3"
              >Clear All ({{ selectedFilterLength }})</span
            >
          </div>
          <div
            style="min-height: 10px; overflow: auto; height: 100px"
            id="selectedSection"
          >
            <SelectedTags
              :currentPageSchema="currentPageSchema"
              :onlySelectedFilters="onlySelectedFilters"
              :clearCallback="onInput"
            />
          </div>
          <div v-if="isCandidateRoute">
            <label class="ml-3">Sort By</label>
            <div class="d-flex mb-1 w-100 align-items-center">
              <div class="col-7 pr-2">
                <Select
                  name="order_by_column"
                  :options="
                    options && options['order_by_columns']
                      ? options['order_by_columns']
                      : []
                  "
                  :taggable="false"
                  :multiple="false"
                  :clearable="false"
                  :value="order_by_column"
                  @change="handleChangeSelect"
                />
              </div>
              <div class="col-5 pl-2">
                <Select
                  name="asc_dsc"
                  :options="
                    options && options['asc_dsc_options']
                      ? options['asc_dsc_options']
                      : []
                  "
                  :taggable="false"
                  :multiple="false"
                  :clearable="false"
                  :value="asc_dsc.label"
                  @change="handleChangeSelect"
                />
              </div>
            </div>
          </div>
        </template>
        <CListGroup v-if="!isFetchingFilter">
          <div
            v-for="(value, propertyName, index) in groupedFilterData"
            :key="index"
          >
            <div v-if="basicFilterlength && basicFilterlength === index">
              <a class="btn btn-lg toggle px-1 w-100" @click="toggleAdvanced()">
                <span name="advancedSearch" class="mr-2">Advanced Search</span>
                <CIcon
                  v-if="!isAdvancedFilterVisible"
                  size="lg"
                  name="cil-plus"
                />
                <CIcon v-else size="lg" name="cil-minus" />
              </a>
            </div>
            <div v-if="value.component && !value.isHide">
              <!--@DO_NOT_REMOVE below commented code
               needed for testing, we replaced this block with AccordionComponent component once geniric filter stable we can remove the code
              -->
              <!-- <div v-show="isBasicFilterShow(index) || isAdvanceFilterShow(index)">
                <CListGroupItem class="py-2 border-1" href="javascript:" @click="showCollapse(index)">
                  <div class="d-flex justify-content-between align-items-center">
                    <p class="m-0">{{ value.label }}</p>
                    <button class="btn shadow-none">
                      <i
                        :class="
                          `fa fa-${collapseIndex === index ? 'minus' : 'plus'}`
                        "
                      ></i>
                    </button>
                  </div>
                </CListGroupItem>
                <CCollapse :show="collapseIndex === index">
                  <CCard class="mx-0 my-0 rounded-0" body-wrapper>
                    <component
                      :is="value.component"
                      :key="index"
                      :name="value.name"
                      :label="''"
                      :placeholder="value.placeholder"
                      :rangeValue="selectedFilters[propertyName][0]"
                      :selectedValue="selectedFilters[propertyName]"
                      :value="selectedFilters[propertyName]"
                      @input="onInput"
                      :onInput="onInput"
                      :options="getDependentOptions(propertyName)"
                      :taggable="value.taggable"
                      :multiple="value.multiple"
                      :clearable="value.clearable"
                      :disabled="isDisable(propertyName)"
                      :fetchOptions="fetchOptions"

                      :groupName="value.name"
                      :groupFilterSchema="value.schema"
                      :selectedFilters="selectedFilters"
                      :getDependentOptions="getDependentOptions"
                      :isDisable="isDisable"
                    />
          
                  </CCard>
                </CCollapse>
              </div> -->
              <AccordionComponent
                :basicFilterlength="basicFilterlength"
                :isAdvancedFilterVisible="isAdvancedFilterVisible"
                :collapseIndex="collapseIndex"
                :index="index"
                :showCollapse="showCollapse"
                :value="value"
                :selectedFilters="selectedFilters"
                :propertyName="propertyName"
                :getDependentOptions="getDependentOptions"
                :isDisable="isDisable"
                :onInput="onInput"
                :fetchOptions="fetchOptions"
                :accordionFetchOption="accordionFetchOption"
                :specialitySmartOptions="specialitySmartOptions"
              />
            </div>
            <div v-else-if="!value.isHide">
              <div
                v-show="index < basicFilterlength || isAdvancedFilterVisible"
              >
                <CListGroupItem
                  class="py-2 border-1"
                  href="javascript:"
                  @click="showCollapse(`${propertyName}${index}`)"
                >
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <p class="m-0">{{ propertyName.replace("_", " ") }}</p>
                    <button class="btn shadow-none">
                      <i
                        :class="`fa fa-${
                          collapseIndex === `${propertyName}${index}`
                            ? 'minus'
                            : 'plus'
                        }`"
                      ></i>
                    </button>
                  </div>
                </CListGroupItem>
              </div>
              <CCollapse :show="collapseIndex === `${propertyName}${index}`">
                <CCard class="mx-0 my-0 rounded-0" body-wrapper>
                  <div
                    v-for="(gpvalue, gppropertyName, gpindex) in value"
                    :key="gpindex"
                  >
                    <AccordionComponent
                      v-if="!gpvalue.isHide"
                      :basicFilterlength="basicFilterlength"
                      :isAdvancedFilterVisible="isAdvancedFilterVisible"
                      :collapseIndex="collapseIndex"
                      :index="gpindex"
                      :showCollapse="showCollapse"
                      :value="gpvalue"
                      :selectedFilters="selectedFilters"
                      :propertyName="gppropertyName"
                      :getDependentOptions="getDependentOptions"
                      :isDisable="isDisable"
                      :onInput="onInput"
                      :groupName="propertyName"
                      :fetchOptions="fetchOptions"
                      :accordionFetchOption="accordionFetchOption"
                      :specialitySmartOptions="specialitySmartOptions"
                    />
                  </div>
                </CCard>
              </CCollapse>
            </div>
          </div>
        </CListGroup>

        <!-- <template #footer>
        <h1>Here is your footer</h1>
        </template>-->
      </sidebar>
      <!-- <div id="filters" class="d-inline col-1" v-bind:class="{'show': isActive}"></div> -->
    </div>
    <div class="mb-3">
      <SelectedTags
        :currentPageSchema="currentPageSchema"
        :onlySelectedFilters="onlySelectedFilters"
        :clearCallback="onInput"
      />
    </div>
    <BookmarkFilter
      :modalTitle="bookmarkFilterModal.modalTitle"
      :modalColor="bookmarkFilterModal.modalColor"
      :isShowPopup="bookmarkFilterModal.isShowPopup"
      :isBookmarkEdit="bookmarkFilterModal.isBookmarkEdit"
      :bookmark_id="bookmarkFilterModal.bookmark_id"
      :closeModal="closeModal"
      :filter_name="bookmarkFilterModal.filter_name"
      :urlPath="bookmarkFilterModal.urlPath"
      :page_name="bookmarkFilterModal.page_name"
      v-if="bookmarkFilterModal.isShowPopup"
    />
    <Modal
      :modalTitle="deleteModal.modalTitle"
      :modalColor="deleteModal.modalColor"
      :modalContent="deleteModal.modalContent"
      :isShowPopup="deleteModal.isShowPopup"
      :buttons="deleteModal.buttons"
      :modalCallBack="modalCallBack"
      :closeOnBackdrop="deleteModal.closeOnBackdrop"
      v-if="deleteModal.isShowPopup"
    />
    <AddGroupModal
      :modalTitle="addGroupModal.modalTitle"
      :modalColor="addGroupModal.modalColor"
      :isShowPopup="addGroupModal.isShowPopup"
      :isJobGroupEdit="addGroupModal.isJobGroupEdit"
      :group_id="addGroupModal.group_id"
      :closeModal="closeModal"
      :group_name="addGroupModal.group_name"
      v-if="addGroupModal.isShowPopup"
    />
  </div>
</template>

<script>
import Vue from "vue";
import sidebar from "./sidebar";
import SearchBar from "./searchComponent";
import {
  isObject,
  isEmptyObjectCheck,
  Role,
  getDefaultBookmark,
  deepClone,
  isSuperCustomer,
} from "@/helpers/helper";
import SelectedTags from "./selectedTags";
import { mapGetters, mapActions } from "vuex";
import BookmarkFilter from "@/components/reusable/BookmarkFilter";
import AddGroupModal from "@/components/reusable/AddGroupModal";
import Modal from "@/components/reusable/Modal";
import AccordionComponent from "@/components/reusable/GenericFilterAndSearch/AccordionComponent.vue";
import moment from "moment";
import _ from "lodash";
import Select from "../../reusable/Fields/Select.vue";
import CampaignBookmark from "../../../pages/Campaign/CampaignBookmark.vue";
Vue.component("sidebar", sidebar);
Vue.component("SearchBar", SearchBar);
Vue.component("SelectedTags", SelectedTags);
Vue.component("BookmarkFilter", BookmarkFilter);
Vue.component("AddGroupModal", AddGroupModal);
Vue.component("Modal", Modal);
Vue.component("AccordionComponent", AccordionComponent);

export default {
  components: {
    Select,
    CampaignBookmark,
  },
  props: [
    "callback",
    "searchCallback",
    "basicFilterlength",
    "filterSchema",
    "selectedFilters",
    "filterDependencyObj",
    "isFetchingFilter",
    "filterAction",
    "backURL",
    "hideFavoriteBtn",
    "fullBackURL",
  ],
  data() {
    return {
      isActive: true,
      isAdvancedFilterVisible: false,
      sideBarShow: false,
      collapseIndex: null,
      isAddBookmark: false,
      bookmarkFilterModal: {
        modalColor: "primary",
        modalTitle: "Add Favourite Filter",
        size: "lg",
        isShowPopup: false,
        closeOnBackdrop: false,
        isBookmarkEdit: false,
        bookmark_id: null,
        filter_name: null,
        urlPath: "",
        page_name: "",
      },
      addGroupModal: {
        modalColor: "primary",
        modalTitle: "Add Group Filter",
        isShowPopup: false,
        isJobGroupEdit: false,
        group_id: null,
        group_name: null,
      },
      deleteModal: {
        modalTitle: "",
        modalColor: "danger",
        modalContent: "",
        isShowPopup: false,
        buttons: ["Cancel", "Delete"],
        closeOnBackdrop: false,
        filter_bookmark_id: null,
      },
      searchFilterName: "",
      favouriteTemplate: {},
      specialitySmartOptions: [],
      asc_dsc: {
        code: "-",
        label: "Desc",
      },
      order_by_column: {
        code: "created_on",
        label: "Created On",
      },
      isSuperCustomer,
    };
  },
  beforeDestroy() {
    this.clearAllSelectedFilters();
  },
  computed: {
    ...mapGetters([
      "currentPageSchema",
      "favouriteFilters",
      "getUserId",
      "getRole",
      "getJobGroups",
      "getQueryResult",
      "isEducationalInstitute",
    ]),
    isShowGroup() {
      const { recruiter, admin } = Role;
      return (
        ([...recruiter, ...admin].includes(this.getRole) &&
          this.$route?.path.includes("/job-list")) ||
        false
      );
    },
    selectedFilterLength() {
      return Object.keys(this.onlySelectedFilters).length;
    },
    groupedFilterData() {
      let filterObject = {};
      const data = deepClone(this.filterSchema);
      for (let i in data) {
        let item = data[i];
        let key = i;
        if (item?.conditionalLabel) {
          const { conditionalField, value, newLabel } = item.conditionalLabel;
          const val = (Array.isArray(this.selectedFilters[conditionalField]) &&
            this.selectedFilters[conditionalField].map(({ code }) => code)) || [
            this.selectedFilters[conditionalField],
          ];
          if (val.includes(value)) item.label = newLabel;
        }
        if (item?.hideCondition) {
          const { conditionalField, value } = item.hideCondition;
          const val = (Array.isArray(this.selectedFilters[conditionalField]) &&
            this.selectedFilters[conditionalField].map(({ code }) => code)) || [
            this.selectedFilters[conditionalField],
          ];
          if (val && val.length === 0) {
            item.isHide = !item.hideCondition.defaultShow;
          } else {
            if (Array.isArray(value))
              item.isHide = val.some((e) => value.includes(e));
            else item.isHide = val.includes(value);
          }
        }
        let groupFilterName = data[i]["groupFilterName"];
        if (groupFilterName) {
          if (filterObject[groupFilterName]) {
            filterObject[groupFilterName] = {
              ...filterObject[groupFilterName],
              [key]: item,
            };
          } else {
            filterObject[groupFilterName] = { [key]: item };
          }
        } else {
          filterObject = {
            ...filterObject,
            [i]: data[i],
          };
        }
      }
      return filterObject;
    },
    onlySelectedFilters() {
      const onlySelectedData = {};
      const selectedObjectKeys = Object.keys(this.selectedFilters);
      selectedObjectKeys.forEach((element) => {
        let data = this.selectedFilters[element];
        if (element === "searchTerm" && data) {
          if (data?.length)
            onlySelectedData[element] =
              typeof data === "string" ? [data] : data;
        } else if (
          this.currentPageSchema[element] &&
          this.currentPageSchema[element]["component"] === "filterRange" &&
          data.length
        ) {
          onlySelectedData[element] = data.map((val) => ({
            label: val,
            code: val,
          }));
        } else if (Array.isArray(data) && data.length) {
          onlySelectedData[element] = data;
        } else if (isObject(data) && !isEmptyObjectCheck(data)) {
          onlySelectedData[element] = [data];
        }
      });
      return onlySelectedData;
    },
    searchTerm() {
      return this.selectedFilters["searchTerm"] || "";
    },
    isBasicFilterShow() {
      return (index) => {
        if (!this.basicFilterlength) {
          return true;
        }
        return this.basicFilterlength > index;
      };
    },
    isAdvanceFilterShow() {
      return (index) => {
        return (
          this.basicFilterlength &&
          this.basicFilterlength <= index &&
          this.isAdvancedFilterVisible
        );
      };
    },
    isDisable() {
      return (propertyName) => {
        const secondLevelDependentDisable =
          this.filterSchema[propertyName]?.secondLevelDependentDisable;
        const selectInversionDependentDisable =
          this.filterSchema[propertyName]?.selectDependentDisable;
        if (secondLevelDependentDisable && secondLevelDependentDisable.length) {
          let secondLevelDepArray =
            this.filterSchema[propertyName]?.secondLevelDependentDisable;
          const dependsOn =
            this.filterSchema[propertyName]?.secondLevelDependentDisable?.[0];
          const selectedDependent = this.selectedFilters[dependsOn];
          //Comment #1 -- Disabled candidate level if candidate type is AHP (code=3)... Code starts here
          if (
            propertyName == "candidateLevel" &&
            secondLevelDependentDisable?.some(
              (val) => val == "candidateType"
            ) &&
            (Array.isArray(selectedDependent) || isObject(selectedDependent))
          ) {
            if (
              selectedDependent.code === 3 ||
              selectedDependent[0]?.code === 3
            )
              return true;
          }
          //Comment #1 -- code ends
          // Disabled Eligibility for Non-Clinical/Admin candidate type
          if (
            propertyName == "pqrCountries" &&
            secondLevelDependentDisable?.some(
              (val) => val == "candidateType"
            ) &&
            (Array.isArray(selectedDependent) || isObject(selectedDependent))
          ) {
            if (
              selectedDependent.code === 6 ||
              selectedDependent[0]?.code === 6
            )
              return true;
          }
          if (Array.isArray(selectedDependent) && !selectedDependent.length) {
            return true;
          }
          if (
            isObject(selectedDependent) &&
            isEmptyObjectCheck(selectedDependent)
          ) {
            return true;
          }
        }
        if (
          selectInversionDependentDisable &&
          selectInversionDependentDisable.length
        ) {
          const selectDependentDisable =
            this.filterSchema[propertyName]?.selectDependentDisable;
          let disableCheck = false;
          selectDependentDisable.map((item) => {
            const dependsOn = item;
            const selectedDependent = this.selectedFilters[dependsOn];
            if (Array.isArray(selectedDependent) && selectedDependent.length) {
              disableCheck = true;
            }
            if (
              isObject(selectedDependent) &&
              !isEmptyObjectCheck(selectedDependent)
            ) {
              disableCheck = true;
            }
          });
          return disableCheck;
        }
        if (
          this.filterSchema[propertyName]?.conditions &&
          Array.isArray(this.filterSchema[propertyName]?.conditions) &&
          this.filterSchema[propertyName]?.conditions.length
        ) {
          let res = true;
          this.filterSchema[propertyName]?.conditions.forEach((ele) => {
            const v = ele.values || [];
            const condi = v.includes(
              this.selectedFilters[ele["field"]]?.code ||
                this.selectedFilters[ele["field"]][0]?.code
            );
            if (condi) {
              res = false;
              return;
            }
          });
          return res;
        }
        return false;
      };
    },
    getDependentOptions() {
      return (propertyName) => {
        if (
          !this.filterDependencyObj ||
          !this.filterDependencyObj[propertyName]
        ) {
          return [];
        }
        if (
          this.filterSchema[propertyName]["component"] === "customSelectOption"
        ) {
          return this.filterDependencyObj[propertyName]["defaultEntries"];
        }
        if (this.filterSchema[propertyName]["dependsOn"].length) {
          const dependentOptions = [];
          let selectedDependentIds = [];
          let dependsOn = this.filterSchema[propertyName]["dependsOn"][0];
          if (propertyName === "locations") {
            let selectedDependentIdsObj = {};
            const depends = this.filterSchema[propertyName]["dependsOn"];
            depends.forEach((item) => {
              const selectedDependent = this.selectedFilters[item];
              if (!Array.isArray(selectedDependent)) {
                if (!selectedDependentIdsObj[item]) {
                  selectedDependentIdsObj[item] = [];
                }
                selectedDependent["code"] && selectedDependent["code"]
                  ? selectedDependentIdsObj[item].push(
                      selectedDependent["code"]
                    )
                  : null;
              } else {
                if (!selectedDependentIdsObj[item]) {
                  selectedDependentIdsObj[item] = [];
                }
                selectedDependent.length
                  ? (selectedDependentIdsObj[item] = [
                      ...selectedDependentIdsObj[item],
                      ...selectedDependent.map((val) => val?.code),
                    ])
                  : [];
              }
            });

            if (!isEmptyObjectCheck(selectedDependentIdsObj)) {
              const keys = Object.keys(selectedDependentIdsObj)
                const item = keys.filter(k=>selectedDependentIdsObj[k].length).at(-1);
                if(item){
                const ids = selectedDependentIdsObj[item];
                ids.forEach((id) => {
                    const depOptions =
                      this.filterDependencyObj[propertyName][item][id];
                    if (depOptions) {
                      this.filterDependencyObj[propertyName][item][id].forEach(
                        (option) => {
                          if (
                            !dependentOptions.some(
                              (val) => val.code === option.code
                            )
                          ) {
                            dependentOptions.push(option);
                          }
                        }
                      );
                    }
                });
              
                return dependentOptions;
              }
            }
            return (
            this.filterDependencyObj[propertyName]?.["defaultEntries"] || []
          );
          } else {
            const selectedDependent = this.selectedFilters[dependsOn];
            // Based on schema multiple option false, array will be mutated to object
            // based on array validation
            if (!Array.isArray(selectedDependent)) {
              selectedDependentIds = selectedDependent["code"]
                ? [selectedDependent["code"]]
                : [];
            } else {
              selectedDependentIds = selectedDependent.length
                ? selectedDependent.map((val) => val?.code)
                : [];
            }
            if (selectedDependentIds.length) {
              selectedDependentIds.forEach((id) => {
                const depOptions =
                  this.filterDependencyObj[propertyName][dependsOn][id];
                if (depOptions) {
                  dependentOptions.push(
                    ...this.filterDependencyObj[propertyName][dependsOn][id]
                  );
                }
              });
              // if(["locationRegion"].includes(dependsOn)) {
              //   dependentOptions.unshift({ code: 'all', label: 'All'});
              // }
              return dependentOptions;
            }
            return (
            this.filterDependencyObj[propertyName]?.["defaultEntries"] || []
          );
          }
          
        } else {
          return (
            this.filterDependencyObj[propertyName]?.["defaultEntries"] || []
          );
        }
      };
    },
    favouriteFilterList() {
      return (searchKey) => {
        let { path } = this.$route;
        const { customerAdmin, systemAdmin } = Role;
        const defaultFilter = getDefaultBookmark(path);
        let favouriteFilters = this.favouriteFilters || [];
        let isDefaultFilterAdded =
          this.favouriteFilters.filter((item) => item.isDefault === true)
            .length === 0;
        if (
          (this.getRole === systemAdmin || this.getRole === customerAdmin) &&
          isObject(defaultFilter) &&
          !isEmptyObjectCheck(defaultFilter) &&
          isDefaultFilterAdded
        ) {
          favouriteFilters.unshift(defaultFilter);
        }
        return favouriteFilters
          .map((val) => {
            const { filter_name, last_modified_on, created_on, isDefault } =
              val;
            let filter_name_date = filter_name;
            if (!isDefault) {
              let filter_date = last_modified_on || created_on;
              filter_date = moment(filter_date).format("DD-MMM-YYYY");
              filter_name_date = `${filter_name} (${filter_date})`;
            }
            return {
              ...val,
              filter_name_date,
            };
          })
          .filter(
            (val) =>
              val.filter_name.toLowerCase().indexOf(searchKey.toLowerCase()) >
              -1
          );
      };
    },
    options() {
      return {
        asc_dsc_options: [
          { code: true, label: "Asc" },
          { code: false, label: "Desc" },
        ],
        order_by_columns: [
          {
            code: "first_name",
            label: "First Name",
          },
          {
            code: "surname",
            label: "Surname",
          },
          {
            code: "email",
            label: "Email",
          },
          {
            code: "created_on",
            label: "Created On",
          },
          {
            code: "last_modified_by",
            label: "Updated On",
          },
        ],
      };
    },
    isCandidateRoute() {
      return this.$route && this.$route.path.includes("candidate-list");
    },
  },
  created() {
    this.selectedAdvancedFilterOpen();
  },
  methods: {
    ...mapActions([
      "clearAllSelectedFilters",
      "dynamicSearchAction",
      "fetchFavouriteFilter",
      "deleteFavouriteFilter",
      "updateSelectedFilterFromFilterCode",
      "initAllFilters",
      "fetchJobGroups",
      "deleteJobGroup",
      "updateSelectedFilter",
      "downloadShortRegCandidates",
    ]),
    handleChangeSelect(name, value) {
      if (value.code === true) {
        this[name] = "";
      } else if (value.code === false) {
        this[name] = "-";
      } else {
        this[name] = value;
      }
      let v = `${this.asc_dsc}${
        this.order_by_column.code
          ? this.order_by_column.code
          : this.order_by_column
      }`;
      this.$store.commit("UPDATE_ORDER_BY_COLUMN", v);
      this.$emit("changeOrder", v);
    },
    fetchOptions(search, loading, propertyName) {
      let actionName =
        this.filterSchema[propertyName]["filterDynamicSearchAction"];
      if (actionName) {
        let dependentQuerys =
          this.filterSchema[propertyName]["dependentQuerys"];
        let { query } = this.$route;
        let dynamicQueryString = "";
        dependentQuerys.forEach((queryItem) => {
          let queryKey = this.filterSchema[queryItem]["queryKey"];
          let queryResult = query[queryItem];
          if (actionName === "genericSpecialitySearch") {
            queryKey = "candidate_type_id";
            queryResult = queryResult[1];
          }
          if (queryKey && queryResult)
            dynamicQueryString += `&${queryKey}=${queryResult}`;
        });
        dynamicQueryString = `query=${search}${dynamicQueryString}`;
        if (actionName == "genericSpecialitySearch" && search.length < 3) {
          return;
        } else {
          this.dynamicSearchAction({
            query: dynamicQueryString,
            loading,
            actionName,
            search,
          });
        }
      }
      return;
    },
    async accordionFetchOption(search, loading, propertyName, cb) {
      let actionName =
        this.filterSchema[propertyName]["filterDynamicSearchAction"];
      let dependentQuerys = this.filterSchema[propertyName]["dependentQuerys"];
      let { query } = this.$route;
      let dynamicQueryString = "";
      dependentQuerys.forEach((queryItem) => {
        let queryKey = this.filterSchema[queryItem]["queryKey"];
        let queryResult = query[queryItem];
        if (actionName === "genericSpecialitySearch") {
          queryKey = "candidate_type_id";
          queryResult = queryResult[1];
        }
        if (queryKey && queryResult)
          dynamicQueryString += `&${queryKey}=${queryResult}`;
      });
      dynamicQueryString = `query=${search}${dynamicQueryString}`;
      if (actionName) {
        if (actionName == "genericSpecialitySearch" && search.length < 3) {
          cb(null, []);
        } else {
          await this.dynamicSearchAction({
            query: dynamicQueryString,
            loading,
            actionName,
            search,
          }).then(async (res) => {
            const options = await this.convertOptionsToTreeOptions(
              this.getDependentOptions("specialitySearch")
            );
            this.specialitySmartOptions = options;
            cb(null, options);
          });
        }
      }
    },
    selectedAdvancedFilterOpen() {
      let { query } = this.$route;
      const queryKeys = Object.keys(query);
      const advancedFilterKeys = Object.keys(this.filterSchema).slice(
        this.basicFilterlength
      );
      if (queryKeys && queryKeys.length) {
        queryKeys.forEach((element) => {
          if (advancedFilterKeys.includes(element)) {
            this.isAdvancedFilterVisible = true;
            return;
          }
        });
      }
    },
    toggleAdvanced() {
      this.isAdvancedFilterVisible = !this.isAdvancedFilterVisible;
    },
    onInput(name, value, type) {
      // value = value || []; // TODO
      if (name === "searchTerm") {
        this.searchCallback({ type: "searchTerm", name, value });
        this.callback({ name, value, type: "searchTerm" });
      } else {
        this.callback({ name, value, type });
      }
    },
    toggleFilter: function () {
      this.isActive = !this.isActive;
    },
    toggleSideBar() {
      this.sideBarShow = !this.sideBarShow;
      this.collapseIndex = null;
    },
    showCollapse(index) {
      if (this.collapseIndex === index) {
        this.collapseIndex = null;
        return;
      }
      this.collapseIndex = index;
    },
    addBookmarkModal() {
      let { fullPath, path } = this.$route;
      this.bookmarkFilterModal = {
        ...this.bookmarkFilterModal,
        modalTitle: `Add ${this.favouriteTemplate.content}`,
        isShowPopup: true,
        isBookmarkEdit: false,
        bookmark_id: null,
        filter_name: null,
        urlPath: fullPath,
        page_name: path,
      };
    },
    closeModal() {
      this.bookmarkFilterModal.isShowPopup = false;
      this.addGroupModal.isShowPopup = false;
    },
    navigateToBookMarkedUrl(url) {
      this.$router
        .push({
          path: url,
        })
        .then((res) => {
          this.initAllFilters().then(() => {
            this.clearAllSelectedFilters();
            this.updateSelectedFilterFromFilterCode(
              this.$router.currentRoute.query
            );
          });
        });
    },
    navigateToGroupUrl(group = null) {
      let value = group
        ? [{ label: group.group_name, code: group.group_id }]
        : [];
      let payloadData = {
        name: "jobGroups",
        value: value,
      };
      let appendAction = [this.updateSelectedFilter(payloadData)];
      Promise.all(appendAction).then((res) => {
        let path = `${this.$route.path}?${this.getQueryResult.routeUrl}`;
        this.$router.push({ path });
      });
    },
    editBookmark(data) {
      let { filter_bookmark_id, filter_name, page_name, url } = data;
      this.bookmarkFilterModal = {
        ...this.bookmarkFilterModal,
        modalTitle: `Edit ${this.favouriteTemplate.content}`,
        isShowPopup: true,
        isBookmarkEdit: true,
        bookmark_id: filter_bookmark_id,
        filter_name: filter_name,
        urlPath: url,
        page_name: page_name,
      };
    },
    deleteBookmark(data) {
      let { filter_name, filter_bookmark_id } = data;
      this.deleteModal.modalTitle = "NOTIFICATION";
      this.deleteModal.modalContent =
        "Do you want to Delete Favourite Filter - " + filter_name;
      this.deleteModal.isShowPopup = true;
      this.deleteModal.filter_bookmark_id = filter_bookmark_id;
    },
    modalCallBack(action) {
      if (action === "Delete") {
        if (this.deleteModal.filter_bookmark_id) {
          let { path } = this.$route;
          let payload = {
            filter_bookmark_id: this.deleteModal.filter_bookmark_id,
            page_name: path,
          };
          this.deleteFavouriteFilter(payload);
        } else if (this.deleteModal.group_id) {
          this.deleteJobGroup(this.deleteModal.group_id).then((res) =>
            this.navigateToGroupUrl()
          );
        }
      }
      this.deleteModal.isShowPopup = false;
    },
    clearAllFilters() {
      this.clearAllSelectedFilters().then((res) => {
        this.callback(this.selectedFilters);
      });
    },
    setFavouriteTemplate() {
      let { fullPath, path } = this.$router.history.current;
      if (
        path == "/jobs-list" &&
        (this.getRole == Role.customerCandidate ||
          this.getRole == Role.systemCandidate)
      ) {
        if (fullPath.search("preferredType") != -1) {
          this.favouriteTemplate =
            fullPath.search("favourite") != -1
              ? { name: "Favourite Jobs", content: "Preferred Filter" }
              : { name: "Applied Jobs", content: "Preferred Filter" };
        } else {
          this.favouriteTemplate = {
            name: "My Preferences",
            content: "Preferred Filter",
          };
        }
      } else {
        this.favouriteTemplate = {
          name: "Favourites",
          content: "Favourite Filter",
        };
      }
    },
    convertOptionsToTreeOptions(options) {
      let r =
        (options &&
          _.reduce(
            options,
            function (result, value, key) {
              result && result.length ? null : (result = []);
              if (value?.group_by) {
                let _groupByindex = _.findIndex(result, {
                  label: value?.group_by,
                });
                let sub_spl_label = value?.sub_speciality;
                let spl_label = value?.speciality;
                const cCode = value?.speciality_reference_group
                  ? value?.speciality_reference_group
                  : value?.code;
                if (_groupByindex < 0) {
                  let opt = {
                    id: `parent-[${cCode}]`,
                    label: value?.group_by,
                    checkBox: false,
                    children: [
                      {
                        id: value?.code,
                        label: spl_label,
                        checkBox: true,
                        spl_label,
                        sub_spl_label,
                      },
                    ],
                    isParent: true,
                  };
                  if (value?.group_by.includes("Sub Speciality")) {
                    opt = {
                      ...opt,
                      children: [
                        {
                          id: `[${value?.code}]`,
                          label: spl_label,
                          spl_label,
                          sub_spl_label,
                          checkBox: true,
                          children: [
                            {
                              id: value?.code,
                              label: sub_spl_label,
                              spl_label,
                              sub_spl_label,
                            },
                          ],
                        },
                      ],
                    };
                  }
                  result.push(opt);
                } else {
                  if (!result[_groupByindex].id.includes(cCode))
                    result[_groupByindex].id += `,${cCode}`;

                  let _Cindex = _.findIndex(result[_groupByindex].children, {
                    label: spl_label,
                  });
                  if (_Cindex < 0) {
                    let ccData = {
                      id: value?.code,
                      label: spl_label,
                      sub_spl_label,
                      spl_label,
                      checkBox: true,
                    };
                    if (value?.group_by.includes("Sub Speciality")) {
                      ccData = {
                        id: `[${value?.code}]`,
                        label: spl_label,
                        sub_spl_label,
                        spl_label,
                        checkBox: true,
                        children: [
                          {
                            id: value?.code,
                            label: sub_spl_label,
                            sub_spl_label,
                            spl_label,
                            checkBox: true,
                          },
                        ],
                      };
                    }

                    result[_groupByindex].children.push(ccData);
                  } else {
                    if (!result[_groupByindex].children[_Cindex].children) {
                      let _Cvalue = result[_groupByindex].children[_Cindex];
                      let _cId = value?.speciality_reference_group
                        ? value?.speciality_reference_group
                        : _Cvalue.id;
                      result[_groupByindex].children[_Cindex] = {
                        id: _cId,
                        label: spl_label,
                        checkBox: true,
                        children: [
                          {
                            id: _Cvalue.id,
                            label: _Cvalue.sub_spl_label,
                            spl_label: _Cvalue.spl_label,
                            sub_spl_label: _Cvalue.sub_spl_label,
                            checkBox: true,
                          },
                        ],
                      };
                    }
                    result[_groupByindex].children[_Cindex].children.push({
                      id: value?.code,
                      label: sub_spl_label,
                      spl_label,
                      sub_spl_label,
                    });
                    if (!value?.speciality_reference_group) {
                      result[_groupByindex].children[
                        _Cindex
                      ].id += `,${value.code}`;
                    }
                  }
                }
              }
              return result;
            },
            []
          ).sort((a, b) => {
            return a.label.includes("Main Speciality") ? -1 : 1;
          })) ||
        [];
      return r;
    },
    addJobGroup() {
      this.addGroupModal = {
        ...this.addGroupModal,
        modalTitle: `Add Job Group`,
        isShowPopup: true,
        isJobGroupEdit: false,
        group_id: null,
        group_name: null,
      };
    },
    editJobGroup(group) {
      this.addGroupModal = {
        ...this.addGroupModal,
        modalTitle: `Edit Job Group`,
        isShowPopup: true,
        isJobGroupEdit: true,
        group_id: group.group_id,
        group_name: group.group_name,
      };
    },
    removeJobGroup(group) {
      this.deleteModal = {
        ...this.deleteModal,
        modalTitle: "NOTIFICATION",
        modalContent: `Do you want to Delete Job Group - ${group.group_name}`,
        isShowPopup: true,
        group_id: group.group_id,
      };
    },
    showTableView() {
      this.$emit("changeToTableView");
    },
  },
  mounted() {
    if (this.getUserId) {
      const { path } = this.$route;
      this.fetchFavouriteFilter(path);
      this.fetchJobGroups();
    }
    this.setFavouriteTemplate();
  },
  //multiple api calls are triggering due to this code block, If anything breaks in existing code, work around inside individual components.
  watch: {
    "$route.query": function (newVal, oldVal) {
      const newQuery = _.reduce(
        newVal,
        function (result, value, key) {
          return _.isEqual(
            value?.replace(/\s/g, ""),
            oldVal[key]?.replace(/\s/g, "")
          )
            ? result
            : value
            ? result.concat(key)
            : result;
        },
        []
      ).filter((val) => val);
      if (newQuery.length === 1 && newQuery.includes("job_id")) return;
      if (newQuery.length === 1 && newQuery.includes("page")) return;
      const includesAny = (arr, values) => values.some((v) => arr.includes(v));
      if (
        newQuery.length === 1 &&
        includesAny(
          ["specialitySearch", "locationRegion", "preferredLocations"],
          newQuery
        )
      ) {
        this.filterAction(true);
      } else {
        this.filterAction();
        this.setFavouriteTemplate();
      }
    },
  },
};
</script>

<style lang="scss">
.tfm_job_board {
  .text-primary {
    color: #331e94 !important;
  }

  .btn,
  .btn-primary {
    background-color: #331e94 !important;
    border-color: #331e94 !important;
    color: white !important;
  }
}
.generic-filter {
  display: flex;
  padding: 4px 0;
  border: 1px solid #c9cbce;
  color: #00626a;
  background-color: #f1f2f5;
  align-items: center;
  justify-content: space-between;
  p {
    font-weight: 600;
    font-size: 18px;
  }
}
.text-color {
  color: #00626a;
}
.dropdown-menu .items {
  width: 200px;
}
.dropdown-menu label {
  width: 140px;
}
.filter-list {
  max-height: 250px;
  overflow-y: auto;
}
.filter-search {
  width: 230px;
}
</style>
